module.exports = __webpack_public_path__ + "static/media/mini-envios.2a93480f.jpg";